(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager-payment-flow/payment-failure/assets/javascripts/payment-failure.js') >= 0) return;  svs.modules.push('/components/wager-payment-flow/payment-failure/assets/javascripts/payment-failure.js');
"use strict";


const dialog = svs.components.dialog;
const Confirm = dialog.Confirm,
  branding = dialog.branding,
  type = dialog.type,
  message = dialog.message;
const canPlayOnVertical = svs.accountservices.player_exclusions.canPlayOnVertical;
const _svs$components$wager = svs.components.wagerPaymentFlow.paymentFailure.utils,
  getActionAndIconForError = _svs$components$wager.getActionAndIconForError,
  showSuspensionMessage = _svs$components$wager.showSuspensionMessage;
const ClientErrorCodes = svs.components.payment.common.error.constants.ClientErrorCodes;
const paymentFailureDialog = async function () {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    title = _ref.title,
    errorMessage = _ref.message;
  let clientCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ClientErrorCodes.GENERIC;
  if (clientCode === ClientErrorCodes.SUSPENSION) {
    showSuspensionMessage();
  } else if (clientCode === ClientErrorCodes.VERTICAL_EXCLUSION) {
    const canPlay = await canPlayOnVertical('tipsspel');
    canPlay && paymentFailureDialog({
      title: 'Prova igen om en stund',
      message: 'Något gick tyvärr fel'
    }, ClientErrorCodes.GENERIC);
  } else {
    const _getActionAndIconForE = getActionAndIconForError(clientCode),
      errorAction = _getActionAndIconForE.actions,
      icon = _getActionAndIconForE.icon;
    dialog.api.add(new Confirm({
      branding: branding.SPORT,
      area: dialog.area.POPUP,
      autoClose: 0,
      icon: icon !== null && icon !== void 0 ? icon : 'exclamation-sign',
      type: type.DEFAULT,
      title: title !== null && title !== void 0 ? title : 'Något gick visst fel',
      message: Array.isArray(errorMessage) ? errorMessage.map(text => ({
        type: message.TEXT,
        text,
        align: svs.components.dialog.message.align.CENTER
      })) : [{
        type: message.TEXT,
        text: errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Försök igen lite senare'
      }],
      actions: errorAction ? errorAction : [{
        title: 'Okej',
        showLoader: true,
        callback() {
          dialog.api.close();
        }
      }]
    }));
  }
};
setGlobal('svs.components.wagerPaymentFlow.paymentFailure.paymentFailureDialog', paymentFailureDialog);

 })(window);